<script>
  export default {
    name: 'form-cancel-button',
    props: ['routeName']
  }
</script>

<template>
    <router-link :to="{name: routeName}"
                 class="el-button el-button--default">Cancelar
    </router-link>
</template>



// WEBPACK FOOTER //
// CancelButton.vue?b238d9c2